import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';
import { baseLevelSchema } from '~/util/types/levels';
import { submissionStatus } from '~/util/types/submissions';
import { baseUserSchema } from '~/util/types/users';

export const submissionsParamsSchema = z
    .object({
        level: baseLevelSchema.nullable().default(null),
        submitter: baseUserSchema.nullable().default(null),
        reviewer: baseUserSchema.nullable().default(null),
        status: z.enum(submissionStatus).nullable().default(null),
        mobile: z.boolean().nullable().default(null),
        priority: z.boolean().nullable().default(null),
        notes: z.string().nullable().default(null),
        sort: z
            .enum(['CreatedAt', 'UpdatedAt', 'CompletionTime'])
            .default('UpdatedAt'),
        reverseSort: z.boolean().default(false),
    })
    .extend(paginatedQuerySchema().shape);

export type submissionsParamsType = z.infer<typeof submissionsParamsSchema>;

export const defaultSubmissionsParams = submissionsParamsSchema.parse({});
